module.exports = __webpack_public_path__ + "static/media/arr_d_3.d6d7ad2e.svg";